import React from 'react'
import { QuestionCard } from './components/questionCard'
import { Box, Typography } from '@mui/material'
import { useStyles } from './styles'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import { SectionData } from '../../../../../../service/questionarie/response'

export const SectionCard = ({title, percentage, sumCorrectOption, totalScoreCorrect, questions}:SectionData) => {
    const styles = useStyles()
  return (
    <>
    <CustomPaper id={'3'} elevation={3} sx={{margin: '5px 5px 30px 5px'}}>
      <Box sx={styles.container}>
        <Typography variant='blue_title'>{title}</Typography>
          <Box sx={styles.right}>
              <Typography sx={styles.porcentaje({porcentaje:percentage})}>{percentage}%</Typography>
              <Typography sx={styles.completado}>({sumCorrectOption}/{totalScoreCorrect})</Typography>
          </Box>
      </Box>
      {questions.map((questions, index) => (
        <QuestionCard key={index} title={questions.title} answers={questions.answers}/>
      ))}
    </CustomPaper>
    </>
  )
}
